export const isEditorialRatingPathExists = ({ make, model, submodel, year }) =>
  !!(make && model && submodel && year && parseInt(year, 10) >= 2018);

export const isRecommendedTrimPathExists = ({ make, model, year }) => !!(make && model && year);
export const isAveragePricePathExists = ({ make, model, year }) => !!(make && model && year);
